// extracted by mini-css-extract-plugin
module.exports = {"wrap":"GoodsList_wrap__2FSOR","header":"GoodsList_header__2vnJ0","body":"GoodsList_body__2WN7f"};